/**
 * Separate module to work-around circular dependency:
 * s25-datefilter needs this parser, and s25-util needs dateFilter
 *
 * @author mikhail, devin
 */
import { S25Util } from "../../util/s25-util";

export class s25Dateparser {
    public static parse(rawDate: number | string | Date) {
        if (typeof rawDate === "number") return new Date(rawDate); // Assume number is epoch

        // Invalid Date - return undefined for undefined
        if (!rawDate) {
            return undefined;
        }

        // Date object - clone and return
        if (Object.prototype.toString.call(rawDate) === "[object Date]") {
            return S25Util.date.clone(rawDate) as any;
        }

        let date = window.dayjs(rawDate).toDate() as Date;

        // if date is way back in the past and the rawDate did not include that year, assume it is this year
        // eg: `march 2` parses as 2001-03-02, but we want it to be CURRENT_YEAR-03-02
        if (
            date.getFullYear() - new Date().getFullYear() <= -20 &&
            (rawDate as string)?.indexOf(date.getFullYear().toString()) === -1
        ) {
            date.setFullYear(new Date().getFullYear());
        }

        return date;
    }
}
